<template>
  <div>
    <main>
      <slot />
    </main>
    <LazyCookieBanner hydrate-on-idle />
    <LazyContactUsIcons hydrate-on-idle />
    <LazyNavigationFooter hydrate-on-visible />
  </div>
</template>
